export const ACTIONABLE = "actionable";
export const GENERAL = "general";
export const SIMPLE = "simple";
